<template>
    <div
        class="invoice"
        v-if="accounts && currentAccount"
        v-for="(item, i) in accounts"
        :class="{
            noviten: item.cis_division == 'GESK',
            active: item.client_number == currentAccount.client_number,
            indebt: item.saldo && item.saldo.balance && item.saldo.balance.status == 'debit'
        }"
        @click.prevent="selectAccount(item.client_number)"
    >
        <div v-if="item.person" class="invoice-address">{{item.person.results.adrGroup.fullAddress}}</div>
        <div v-else class="invoice-address">Нет адреса</div>
        
        <div class="invoice-number"></div>
        <input-text
            :inputValue="item.client_number"
            class="invoice-number"
            maskVal="invoice"
        />
        <div class="invoice-notice" @click.stop>
            <textarea
                ref="noteTextareas"
                :value="item.note"
                class="notice-input"
                placeholder="Введите заметку"
                rows="1"
                @input="autoResize($event)"
            ></textarea>
            <div class="notice-input__buttons">
                <i class="notice-input__edit" @click.stop="focusNote(i)" @touchstart.stop.prevent="focusNote(i)"></i>
                <div class="notice-input__actions" @mousedown.prevent>
                    <a href="#" class="cancel" @click.stop.prevent="cancelNote(i)" @touchend.stop.prevent="cancelNote(i)"></a>
                    <a href="#" class="apply" @click.stop.prevent="addNote(i)" @touchend.stop.prevent="addNote(i)"></a>
                </div>
            </div>
        </div>
        <router-link
            @click.prevent="selectAccount(item.client_number)"
            class="invoice-edit"
            to="/account/"></router-link>
        <router-link
            v-if="item.saldo && item.saldo.balance && item.saldo.balance.status == 'debit'"
            to="/pay/"
            class="invoice-indebt"
            @click.prevent="selectAccount(item.client_number)"
        >Задолженность {{item.saldo.balance.currentBalance}} руб.</router-link>
        <router-link
            v-if="canInstallment(item)"
            to="/installment/"
            class="invoice-installment"
            @click.prevent="goToInstallment(item.client_number)"
        >Оформить рассрочку</router-link>
    </div>
    <p v-else class="empty-text">У Вас нет лицевых счетов.<br> Вы можете добавить их здесь.</p>
</template>

<script>
import axios from 'axios'
import { passesInstallmentDebtCheck } from '@/store'

export default {
    name: 'user-bar-accounts',
    data() {
        return {
            invoiceMask: {
                mask: '000 000 00'
            },
            apiUrl: this.$store.state.apiUrl,
            token: this.$store.state.token,
        }
    },
    computed: {
        account_id() {
            return this.$store.state.selectAccount
        },
        accounts() {
            let accounts = this.$store.state.accounts

            if (accounts.length) {
                return accounts.sort(this.sortAccounts)
            } else
                return false
        },
        currentAccount() {
            const accounts = this.$store.state.accounts
            const selectAccount = this.$store.state.selectAccount
            
            if (selectAccount && accounts.length) {
                let normalizedTarget = String(selectAccount).replace(/^0+/, '')
                const found = accounts.find(acc => {
                    let normalizedClient = String(acc.client_number).replace(/^0+/, '')
                    return normalizedClient == normalizedTarget
                })
                if (found) {
                    this.$store.state.currentAccount = found
                    return found
                }
            }
            
            if (accounts.length) {
                this.$store.state.currentAccount = accounts[0]
                return accounts[0]
            }
            
            return false
        },
        canInstallment() {
            return this.$store.getters.canInstallment
        },
        installmentCandidatesKey() {
            return this.$store.state.accounts
                .filter(account => passesInstallmentDebtCheck(this.$store.state.installmentDebtLimit, account))
                .map(account => account.account_id + ':' + Number(account.saldo.balance.currentBalance))
                .join(',')
        }
    },
    mounted() {
        if (!this.$store.state.accounts.length)
            this.$store.commit('getAccounts')
        this.loadLastPayments()
        this.$nextTick(() => {
            this.resizeAllNotes()
        })
    },
    watch: {
        accounts() {
            this.$nextTick(() => {
                this.resizeAllNotes()
            })
        },
        installmentCandidatesKey() {
            this.loadLastPayments()
        }
    },
    methods: {
        loadLastPayments() {
            this.$store.state.accounts.forEach(account => {
                if (passesInstallmentDebtCheck(this.$store.state.installmentDebtLimit, account))
                    this.$store.commit('getLastPayment', account.account_id)
            })
        },
        resizeAllNotes() {
            const textareas = this.$refs.noteTextareas
            if (textareas) {
                const list = Array.isArray(textareas) ? textareas : [textareas]
                list.forEach(ta => {
                    ta.style.height = 'auto'
                    ta.style.height = ta.scrollHeight + 'px'
                })
            }
        },
        focusNote(index) {
            const textareas = this.$refs.noteTextareas
            const list = Array.isArray(textareas) ? textareas : [textareas]
            if (list[index]) {
                list[index].focus()
            }
        },
        cancelNote(index) {
            const textareas = this.$refs.noteTextareas
            const list = Array.isArray(textareas) ? textareas : [textareas]
            if (list[index]) {
                list[index].value = this.accounts[index].note || ''
                this.autoResize({ target: list[index] })
            }
        },
        autoResize(event) {
            const textarea = event.target
            textarea.style.height = 'auto'
            textarea.style.height = textarea.scrollHeight + 'px'
        },
        sortAccounts(a, b) {
            return a.client_number - b.client_number
        },
        selectAccount(acctountId) {
            this.account_id = acctountId
            this.$store.commit('setSelectAccount', acctountId)
            this.$store.currentStatement = false
            this.hideAside()
        },
        goToInstallment(clientNumber) {
            this.selectAccount(clientNumber)
            this.$router.push('/installment/')
        },
        hideAside() {
            let aside = document.getElementsByClassName('aside')[0]
            let asideOverlay = document.getElementsByClassName('aside-overlay')[0]

            if (aside.classList.contains('active')) {
                asideOverlay.style.display = 'none'
                aside.classList.remove('active')
            }
        },
        async addNote(index) {
            const textareas = this.$refs.noteTextareas
            const list = Array.isArray(textareas) ? textareas : [textareas]
            const noteVal = list[index] ? list[index].value : ''
            try {
                const response = await axios.patch(
                    this.apiUrl + '/api/user/accounts',
                    {
                        accounts: [
                            {
                                client_number: this.accounts[index].client_number,
                                note: noteVal
                            }
                        ]
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        }
                    }
                )
                this.$store.commit('setAccountNote', {note: noteVal, client_number: this.accounts[index].client_number})
                if (list[index]) {
                    list[index].blur()
                }
            } catch (e) {
                console.log(e.response ? { status: e.response.status, data: e.response.data } : e.message)
            }
        }
    }
}
</script>